/** External */
import React from "react";
import classNames from "classnames";

/** Design System */
import { colors } from "@toddle-edu/ds-theme";

/** Internal */
import classes from "./Tag.scss";

const TagColorStyleMap = {
  neutral: "surfaceDefault textDefault",
  teal: "decorativeSurfaceFiveL decorativeSurfaceFiveD",
  blue: "decorativeSurfaceOneL decorativeSurfaceOneD",
  violet: "decorativeSurfaceTwoL decorativeSurfaceTwoD",
  yellow: "decorativeSurfaceThreeL decorativeSurfaceThreeD",
  pink: "decorativeSurfaceFourL decorativeSurfaceFourD",
};

const Tag = ({ color, children }) => {
  const [light, dark] = TagColorStyleMap[color].split(" ");
  return (
    <div
      className={classes.container}
      style={{
        background: colors[light],
        border: `1px solid ${colors[dark]}`,
      }}
    >
      <div
        className={classNames("text-body-3", classes.tag)}
        style={{ color: colors[dark] }}
      >
        {children}
      </div>
    </div>
  );
};

export default Tag;
